// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8b567586","109":"1e5ace64","287":"62f0bc38","419":"8c9cc0e6","453":"67a11516","490":"4469807d","553":"81054b01","678":"65ab1cef","689":"65e218b0","704":"ce5ea7b3","769":"7e50c03f","814":"455e5a00","955":"d582d961","970":"cab3cd34","985":"1b554bb2"}[chunkId] + ".chunk.js";
};